import React from 'react';
import styled from 'styled-components';
import { useDraggable } from '@dnd-kit/core';
import { theme } from '../../styles/theme';
import { SvgIcon } from '../Icon';
import { IGridPosition } from './types';
import { useDndGridInternalContext } from './context';
import KubitTooltip from '../KubitTooltip';

const StyledButton = styled.button`
  width: 12px;
  height: 12px;
  padding: 0;
  cursor: move;
  color: ${theme.colors.secondary900};
  &:focus,
  &:hover {
    color: ${theme.colors.mainBlue};
  }
`;

interface IDndGridHandleProps extends IGridPosition {
  id: string;
}

export const DndGridDragHandle = ({
  rowIndex,
  colIndex,
  id,
}: IDndGridHandleProps) => {
  const { currentDragHandle, disabled } = useDndGridInternalContext();

  const position: IGridPosition = {
    rowIndex,
    colIndex,
  };
  const { attributes, listeners, setNodeRef } = useDraggable({
    id,
    data: position,
    disabled,
  });

  if (!disabled && currentDragHandle === id) {
    return (
      <KubitTooltip content={'Drag to move'}>
        <StyledButton
          type="button"
          ref={setNodeRef}
          {...listeners}
          {...attributes}
        >
          <SvgIcon
            name="drag-drop"
            width={12}
            height={12}
            customFill="currentColor"
          />
        </StyledButton>
      </KubitTooltip>
    );
  }

  return null;
};
